export function FieldError({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  if (!children) return null;
  return <p className={`text-danger mt-1 text-sm ${className}`}>{children}</p>;
}
